module.exports = __webpack_public_path__ + "static/media/facebook.308f0e8d.png";